import React from 'react';
import { Link } from 'react-router-dom';

const Error = () => {
  return (
    <div className="bg-gray-100 flex h-[30rem] flex-col items-center justify-center">
      <h1 className="text-gray-800 text-9xl font-bold">Under Construction</h1>
      <p className="text-gray-600 text-2xl font-medium">
        We're currently working on this page.
      </p>
      <p className="text-gray-500 text-lg">
        Please check back later or explore other parts of our website.
      </p>
      <Link
        to="/"
        className="mt-8 rounded-md bg-blue-500 px-8 py-3 font-medium text-white hover:bg-blue-600"
      >
        Go Back Home
      </Link>
    </div>
  );
};

export default Error;
